"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LABEL_DELTA = void 0;
exports.getLabelPoint = getLabelPoint;
exports.drawableMarkerCreateBinding = drawableMarkerCreateBinding;
var core_api_1 = require("@ikegps/core-api");
var model_1 = require("../../model");
var draw_state_1 = require("../draw.state");
var label_draw_svg_1 = require("../drawable/label.draw.svg");
var util_draw_svg_1 = require("../drawable/util.draw.svg");
var util_1 = require("../util");
exports.LABEL_DELTA = { x: 0, y: 50 };
function getLabelPoint(uiScale, capture, marker) {
    var labelPoint = { x: capture.resolution.width * 0.75, y: marker.y };
    return (0, util_1.movePoint)(labelPoint, exports.LABEL_DELTA, capture.resolution, {
        width: label_draw_svg_1.LabelSVGDraw.Size.width * uiScale,
        height: label_draw_svg_1.LabelSVGDraw.height(1) * uiScale
    });
}
function createMarkerAt(dc, markerPoint, type) {
    if (type === void 0) { type = core_api_1.MarkerType.NONE; }
    var drawableId = dc.drawState.Mutator.create('marker');
    var drawable = dc.drawState.getDrawable(drawableId);
    var labelPoint = getLabelPoint(dc.state.scale, dc.capture, markerPoint);
    drawable.Mutator.init(markerPoint, labelPoint, type);
    dc.state.setSelected(drawableId, util_draw_svg_1.IkeDrawLabel.LABEL);
    return drawableId;
}
function drawableMarkerCreateBinding(dc, evt) {
    if (dc.state.tool === draw_state_1.IkeDrawTool.BASE) {
        var drawableId = createMarkerAt(dc, evt.center, core_api_1.MarkerType.BASE);
        var drawable = dc.drawState.getDrawable(drawableId);
        // Base Marker's label are shown hard against the left edge
        drawable.label.Mutator.move(0, drawable.label.state.y);
        dc.state.setTool(null);
        dc.state.setCrosshair(false);
        return;
    }
    if (evt.drawableId == null) {
        evt.drawableId = createMarkerAt(dc, evt.center);
    }
    // Ensure that the base / base offset marker does not have any insight flags
    // This should not trigger as we don't support insight base & base offsets made by the back end yet
    if (dc.drawState.insightBase) {
        dc.drawState.insightBase.approveInsightFlag();
    }
    if (dc.drawState.insightBaseOffset) {
        dc.drawState.insightBaseOffset.approveInsightFlag();
    }
    var linkFieldIds = dc.state.linkFieldIds;
    if (linkFieldIds.length > 0) {
        var drawable = dc.drawState.getDrawable(evt.drawableId);
        if (!model_1.CollectionModelDrawableMarker.isNone(drawable)) {
            return;
        }
        for (var _i = 0, linkFieldIds_1 = linkFieldIds; _i < linkFieldIds_1.length; _i++) {
            var linkFieldId = linkFieldIds_1[_i];
            var field = dc.collection.findField(linkFieldId);
            dc.drawState.Mutator.link(drawable, field);
        }
        dc.state.setLinkFields(null);
        dc.state.setSelected(drawable.id, util_draw_svg_1.IkeDrawLabel.LABEL);
        drawable.approveInsightFlag();
    }
    if (evt.$event != null) {
        evt.$event.preventDefault();
    }
}
//# sourceMappingURL=marker.create.binding.js.map